// extracted by mini-css-extract-plugin
export default {"container":"select_container__KPiaJ","select":"select_select__38swQ","asterisk":"select_asterisk__nNbLf"};